export default {"src":"/_next/static/media/home.86dcbe68.svg","height":15,"width":18};